useTableHelper.state = {
    height: null,
    top: null,
    tableContainer: () => document.querySelector('.table-package'),
    headerElementHeight: () => document.querySelector('.package-title').getBoundingClientRect().height,
    tableElement: () => useTableHelper.state.tableContainer().querySelector('table'),
    targetElements: () => document.querySelectorAll('.col-override'),
    // calculate all rows, since we have overflow on table this method is useless, i keep this for legacy reasons
    tableHeight: () => [...useTableHelper.state.tableElement().rows]
        .slice(1, -1)
        .reduce((acc, currentValue) => acc + currentValue.offsetHeight, 0),
    methods: {
        getTableHeight: () => useTableHelper.state.tableElement().getBoundingClientRect().height,
        getTableHeaderHeight: () => useTableHelper.state.tableElement().tHead.getBoundingClientRect().height,
        getTableFooterHeight: () => useTableHelper.state.tableElement().tFoot.getBoundingClientRect().height,
        getTableBodyHeight() {
            return this.getTableHeight() - (this.getTableHeaderHeight() + this.getTableFooterHeight())
        }
    },
}

function useTableHelper() {
    if (!useTableHelper.state.tableContainer()) return;

    useTableHelper.state.height = useTableHelper.state.methods.getTableBodyHeight();
    useTableHelper.state.top = useTableHelper.state.headerElementHeight();

    for (const overrideElement of useTableHelper.state.targetElements()) {
        overrideElement.style.height = `${useTableHelper.state.height}px`;
        overrideElement.style.top = `${useTableHelper.state.top}px`;
    }
}

export default useTableHelper;
